import { render, staticRenderFns } from "./TemplateShortSentences.vue?vue&type=template&id=4e55b9a5&scoped=true&"
import script from "./TemplateShortSentences.vue?vue&type=script&lang=js&"
export * from "./TemplateShortSentences.vue?vue&type=script&lang=js&"
import style0 from "./TemplateShortSentences.vue?vue&type=style&index=0&id=4e55b9a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e55b9a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
